import { ALL_REQUEST_TYPES } from '../constants/request-types';
export const isSubmitButtonDisabled = (dataPrivacyConfig, requestType, country, email, recaptchaToken) => {
  if (!dataPrivacyConfig) {
    return true;
  }
  return !requestType || !email || !recaptchaToken && !!(dataPrivacyConfig !== null && dataPrivacyConfig !== void 0 && dataPrivacyConfig.recaptchaEnabled) || !country && (dataPrivacyConfig === null || dataPrivacyConfig === void 0 ? void 0 : dataPrivacyConfig.showCountrySetting) === 'ENABLED_AND_ENFORCED';
};
export const getRequestTypes = dataPrivacyConfig => {
  if (!dataPrivacyConfig) {
    return [];
  }
  return ALL_REQUEST_TYPES.filter(_requestType => dataPrivacyConfig.requestTypes[_requestType]);
};